export default defineNuxtRouteMiddleware(async (to, from) => {
  if (process.server) return

  // Handle direct page load
  if (!document.referrer) {
    window.localStorage.setItem("redirectUrl", "top")
  }

  try {
    const {
      data: {
        data: { yarnlodId },
      },
    } = await usePost("/yarn/check", {
      yarnlogId: to.params.id,
    })

    if (!yarnlodId) {
      return navigateTo("/404")
    }

    if (Number(yarnlodId) !== Number(to.params.id)) {
      return navigateTo({
        name: to.name,
        params: { id: yarnlodId },
        query: {
          redirectUrl: window.localStorage.getItem("redirectUrl") || "",
        },
        replace: true,
      })
    }
    if (!document.referrer && !to.query.redirectUrl) {
      return navigateTo({
        name: to.name,
        params: { id: yarnlodId },
        query: {
          redirectUrl: window.localStorage.getItem("redirectUrl") || "",
        },
        replace: true,
      })
    }
  } catch (error) {
    console.error("Error checking yarn:", error)
    return navigateTo("/404")
  }
})
